import { render, staticRenderFns } from "./SpecialOneTitle.vue?vue&type=template&id=8dd650f6&scoped=true"
import script from "./SpecialOneTitle.vue?vue&type=script&lang=js"
export * from "./SpecialOneTitle.vue?vue&type=script&lang=js"
import style0 from "./SpecialOneTitle.vue?vue&type=style&index=0&id=8dd650f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd650f6",
  null
  
)

export default component.exports